import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Container,
  IconButton,
} from "@mui/material";

import logo from "../../assets/logo.svg";
// import xLogo from "../../assets/x_logo.svg";
// import tgLogo from "../../assets/tg_logo.svg";
import ghLogo from "../../assets/gh_logo.svg";

const Header = () => {
  return (
    <AppBar
      position="sticky"
      sx={{
        bgcolor: "background.default",
        boxShadow: "0 1px 0 0 rgba(0, 0, 0, 0.1)",
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
          {/* Left navigation */}
          {/* <Box sx={{ display: "flex", gap: 3 }}>
            <Button
              color="inherit"
              sx={{
                textTransform: "none",
                fontWeight: 500,
                fontSize: "16px",
              }}
            >
              Products
            </Button>
            <Button
              color="inherit"
              sx={{
                textTransform: "none",
                fontWeight: 500,
                fontSize: "16px",
              }}
            >
              About
            </Button>
          </Box> */}

          {/* Logo */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              cursor: "pointer",
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="b11a"
              sx={{
                height: 40,
              }}
            />
            <Box
              component="span"
              sx={{
                fontSize: "24px",
                fontWeight: 700,
                color: "black",
              }}
            >
              b11a
            </Box>
          </Box>

          {/* Right section */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box sx={{ display: "flex", gap: 1 }}>
              {/* <IconButton
                href="https://github.com/0xb11a"
                target="_blank"
                color="inherit"
                sx={{
                  padding: "8px",
                  "&:hover": {
                    bgcolor: "rgba(0, 0, 0, 0.04)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={xLogo}
                  alt="X"
                  sx={{
                    width: 24,
                    height: 24,
                  }}
                />
              </IconButton> */}
              {/* <IconButton
                href="https://github.com/0xb11a"
                target="_blank"
                color="inherit"
                sx={{
                  padding: "8px",
                  "&:hover": {
                    bgcolor: "rgba(0, 0, 0, 0.04)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={tgLogo}
                  alt="TG"
                  sx={{
                    width: 24,
                    height: 24,
                  }}
                />
              </IconButton> */}
              <IconButton
                href="https://github.com/0xb11a"
                target="_blank"
                color="inherit"
                sx={{
                  padding: "8px",
                  "&:hover": {
                    bgcolor: "rgba(0, 0, 0, 0.04)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={ghLogo}
                  alt="GitHub"
                  sx={{
                    width: 24,
                    height: 24,
                  }}
                />
              </IconButton>
            </Box>
            {/* <Button
              variant="outlined"
              sx={{
                bgcolor: "#0066FF",
                color: "white",
                textTransform: "none",
                px: 3,
                "&:hover": {
                  bgcolor: "#0052CC",
                },
              }}
              endIcon={
                <Box component="span" sx={{ ml: 0.5 }}>
                  →
                </Box>
              }
            >
              Contact
            </Button> */}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
